import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form';
//import RenderDecimalTextField from './renderDecimalTextFiel';
import { Grid, Button, TextField } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { withStyles } from '@material-ui/styles';
import Countdown from "react-countdown-now";
import Typography from '@material-ui/core/Typography';
import renderTextFieldOtp from './renderTextFieldOtp';

const useStyles = theme => ({
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        color: 'white',
        backgroundColor: "#0097a0",
        "&:hover": {
            backgroundColor: "#0097a0"
        },
        borderRadius: "8px",
        border: "1px solid #fffffe"
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        color: "#878787",
        background: "#0097a0",
        padding: "1% 6% 6% 6%",
        borderRadius: "8px",
        border: "1px solid #0097a0"
    }
})

const validate = values => {
    const error  = {}
    if (!values.data) {
        error.data = "Este campo es obligatorio"
    }
    return error
}
class PropmtForm extends Component {

    renderer = ({ hours, minutes, seconds, completed }) => {
        let newminutes = (minutes < 10) ? '0'+minutes : minutes;
        let newseconds = (seconds < 10) ? '0'+seconds : seconds;
        if (!completed) {
            return <span>{newminutes}:{newseconds}</span>;
        }else{
            return <span>{newminutes}:{newseconds}</span>;
        }
    };

    renderTextField = (
        { input, label, name, type, withFocus, autoFocus, onKeyPress,  meta: { touched, error }},
      ) => {
        //console.log(this.props.onKeyPress)
        return <div>
                  <Grid container spacing={1} justify="center" alignItems="center" direction="column" >
                    <Grid item xs={12} md={12}>
                      <span style={{color:'white', fontSize : "120%"}}>{label}</span>
                    </Grid>
                  </Grid>
                  <div style = {{paddingTop : "10px"}}>
                    <TextField
                            {...input}
                            type={!type ? "text" : type}
                            variant="standard"
                            margin="none"
                            autoComplete="off"
                            fullWidth
                            style={{backgroundColor: 'white', borderRadius: '0px'}}
                            InputLabelProps= {
                              {
                                style: { color: '#fffffe', fontSize : "120%"}
                              }
                            }
                            onKeyPress={ onKeyPress }
                            name={label}
                            id={label}
                            label={''}
                            autoFocus = {autoFocus}
                            ref={withFocus && (txt => { this.txt = txt;} ) }
                            inputProps = {{
                              style : {
                                borderLeft: '4px solid rgba(255, 198, 0)',
                                margin : "5px",
                                paddingLeft : "5px"
                              }
                            }}
                            InputProps={{
                              style : {
                                height : "45px"
                              }
                            }}
                          />
    
                  </div>
              
        </div>
      };

    render() {
        const { classes, handleSubmit, label,cancelPrompt, initialTime, handleChangeInputOtp, onKeyPress, loading  } = this.props;
        // const { data } = dataForm
        return (
            <React.Fragment>
                <div className = {classes.form}>
                    <Typography variant="body2" gutterBottom align = "center" style = {{ color : "#fffffe"}}>
                        <Countdown date={initialTime + 300000}  onComplete = { cancelPrompt } renderer = { this.renderer }/>
                    </Typography>
                    <form  onSubmit={ handleSubmit }>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12} sm={12}>
                            <Field
                                withFocus
                                autoFocus = {true}
                                name="data"
                                type="text"
                                id="data"
                                required
                                disabled={ loading}
                                changeData = {handleChangeInputOtp}
                                component={ renderTextFieldOtp }
                                onKeyPress = { onKeyPress}
                                //color = {"#fffffe"}
                                label={label}
                                fullWidth
                            />
                             </Grid>
                            
                            <Grid item xs={12} md={12} sm={12}>
                                <Button variant="contained" fullWidth onClick = {  cancelPrompt } style = {{
                                  backgroundColor : "#0097a0",
                                  color : "white"
                                }} 
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </React.Fragment>
        )
    }
}

PropmtForm.propTypes = {
 label: PropTypes.string.isRequired,
}
const PromptReduxForm = reduxForm(
    {
      form: 'PropmtForm',
      validate
    }
)(PropmtForm)
export default setPropsAsInitial(withStyles(useStyles)(PromptReduxForm))